export const LOGIN_URL = (
  process.env.REACT_APP_BACKEND_URL +
  '/' +
  process.env.REACT_APP_LOGIN_URL
).replace('//', '/')
export const SAML_LOGOUT_URL = process.env.REACT_APP_SAML_LOGOUT_URL
